import { useEffect } from "react";
import { SeoMeta } from "../types";

export function useDocumentMeta({ title, description }: SeoMeta) {
  useEffect(() => {
    document.title = title;
    document.querySelector('meta[name="description"]')?.setAttribute("content", description);
  }, [description, title]);
}
